<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-25 md-small-size-100">
      <selection-component
        label="communication.staff"
        :data-list="dataList"
        :display-field="displayField"
        :track-by="trackBy"
        @filtering="filterStdUsn"
        ref="selectionsRef"
        @update-selections="updateSelectionsData"
      >
      </selection-component>
    </div>
  </div>
</template>
<script>
import { service_paths } from "@/constants/Services";
import SelectionComponent from "./Selections";
export default {
  name: "Counselor-option",
  components: { SelectionComponent },
  props: ["data"],
  data() {
    return {
      dataList: [],
      currentPath: `${service_paths.staffs}/filter?order_by=full_name`,
      displayField: "full_name",
      trackBy: "_id",
      query: {
        limit: 100,
        role_id: "",
        fields: ["full_name", "student_code"]
      }
    };
  },
  created() {
    this.getRole();
    this.data.filter_by = "Counselor";
  },
  methods: {
    getRole() {
      this.$axios.get(`${service_paths.staffs}/roles`).then(response => {
        this.query.role_id = response.data.find(
          role => role.name === "Counselor"
        ).id;
        this.getDataList();
      });
    },
    getDataList() {
      this.$axios.get(this.currentPath, this.query).then(response => {
        this.dataList = response.data.data;
      });
    },
    filterStdUsn(usnQuery) {
      this.query = {
        ...this.query,
        search_key: usnQuery
      };
      clearTimeout(this.delayTime);
      this.delayTime = setTimeout(() => {
        this.$axios.get(this.currentPath, this.query).then(response => {
          this.dataList = response.data.data;
          const memorizedSelected = this.$refs.selectionsRef.getMemorizedSelected();
          memorizedSelected.forEach(studentSelected => {
            if (!this.dataList.includes(studentSelected))
              this.dataList.push(studentSelected);
          });
        });
      }, 200);
    },
    updateSelectionsData(e) {
      this.data.selectedList = e;
    }
  }
};
</script>
